import React from 'react'

export default function Footer() {
    return (

        <div>

            <footer
                className="text-center text-lg-start text-white w-100 "
            >


                <div
                    className="text-center p-3"
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
                >
                    © 2020 Copyright:
                    <a className="text-white" href="https://mdbootstrap.com/"
                    >MDBootstrap.com</a
                    >
                </div>

            </footer>

        </div>

    )
}
